import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ContentProvider } from "@/hooks/useContent";
import { useSEO } from "@/hooks/useSEO";
import Layout from "@/components/Layout";
import HomePage from "@/pages/HomePage";
import AboutPage from "@/pages/AboutPage";
import QualificationsPage from "@/pages/QualificationsPage";
import PersonalTrainingPage from "@/pages/PersonalTrainingPage";
import NutritionPage from "@/pages/NutritionPage";
import OnlineTrainingPage from "@/pages/OnlineTrainingPage";
import GalleryPage from "@/pages/GalleryPage";
import ReviewsPage from "@/pages/ReviewsPage";
import ShopPage from "@/pages/ShopPage";
import ContactPage from "@/pages/ContactPage";
import FaqPage from "@/pages/FaqPage";
import TransformationsPage from "@/pages/TransformationsPage";
import AdminPage from "@/pages/AdminPage";
import LoginPage from "@/pages/LoginPage";
import ClientDashboard from "@/pages/ClientDashboard";
import PWAInstallPrompt from "@/components/PWAInstallPrompt";

function ScrollToTop() {
  const { pathname } = useLocation();
  useSEO();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function SmartHome() {
  const isPWA = window.matchMedia("(display-mode: standalone)").matches || window.navigator.standalone;
  if (isPWA) {
    const clientToken = localStorage.getItem("gg_client_token") || sessionStorage.getItem("gg_client_token");
    const adminToken = localStorage.getItem("gg_admin_token") || sessionStorage.getItem("gg_admin_token");
    if (clientToken) return <Navigate to="/dashboard" replace />;
    if (adminToken) return <Navigate to="/admin" replace />;
    return <Navigate to="/login" replace />;
  }
  return <HomePage />;
}

function App() {
  return (
    <div className="App font-body">
      <BrowserRouter>
        <ContentProvider>
          <ScrollToTop />
          <PWAInstallPrompt />
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<SmartHome />} />
              <Route path="/home" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/qualifications" element={<QualificationsPage />} />
              <Route path="/personal-training" element={<PersonalTrainingPage />} />
              <Route path="/nutrition" element={<NutritionPage />} />
              <Route path="/online-training" element={<OnlineTrainingPage />} />
              <Route path="/reviews" element={<ReviewsPage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/faq" element={<FaqPage />} />
              <Route path="/transformations" element={<TransformationsPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
            </Route>
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/dashboard" element={<ClientDashboard />} />
          </Routes>
        </ContentProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" theme="dark" />
    </div>
  );
}

export default App;
